export interface SelectOption {
  name: string;
  value: string;
  address?: {
    address1?: string;
    address2?: string;
    city?: string;
    state?: string;
    stateShortCode?: string;
    country?: string;
    countryShortCode?: string;
    zipCode?: string;
  };
}

export enum ImageStatus {
  QUEUED = "QUEUED",
  UPLOADING = "UPLOADING",
  UPLOADED = "UPLOADED",
  FAILED = "FAILED",
  PENDING = "PENDING",
  RETRY = "RETRY",
}

export enum PhotoSource {
  AUTO = "AUTO",
  MANUAL = "MANUAL",
  ADMIN = "ADMIN",
  COMMUNITY = "COMMUNITY",
  BUSINESS = "BUSINESS",
}

export interface BusinessEditPhotoProps {
  rawImage: File | string;
  photoUrl: string;
  status: ImageStatus;
  uuid: string;
  source?: PhotoSource;
}

export interface IOnboardingBusinessProps {}

export interface IBasicDetailsFormProps {
  values: any;
  setFieldValue: (field: string, value: any) => void;
  setFieldTouched: (field: string, isTouched: boolean) => void;
  errors: any;
  touched: any;
  communityOptions: SelectOption[];
  countryOptions: SelectOption[];
  stateOptions: SelectOption[];
  cityOptions: SelectOption[];
  isLoadingCommunities?: boolean;
  isLoadingCountries?: boolean;
  isLoadingStates?: boolean;
  isLoadingCities?: boolean;
  onCommunitySelect?: (community: SelectOption) => void;
}

export interface IAdditionalInformationFormProps {
  values: any;
  setFieldValue: (field: string, value: any) => void;
  setFieldTouched: (field: string, touched?: boolean) => void;
  errors: any;
  touched: any;
  categoryOptions: SelectOption[];
  businessHours: { [key: string]: boolean };
  toggleBusinessHour: (day: string) => void;
  businessHoursTimes: {
    [key: string]: { startTime: string; endTime: string }[];
  };
  setBusinessHoursTimes: React.Dispatch<
    React.SetStateAction<{
      [key: string]: { startTime: string; endTime: string }[];
    }>
  >;
  businessPhones: string[];
  setBusinessPhones: React.Dispatch<React.SetStateAction<string[]>>;
  socialLinks: { platform: string; url: string }[];
  setSocialLinks: React.Dispatch<
    React.SetStateAction<{ platform: string; url: string }[]>
  >;
  externalLinkTypes: Array<{
    metaExternalLinkUuid: string;
    name: string;
    logo: string;
    isOther: boolean;
  }>;
  isLoadingExternalLinks?: boolean;
}

export interface IBusinessPhotosUploadProps {
  uploadedFiles: BusinessEditPhotoProps[];
  setUploadedFiles: React.Dispatch<
    React.SetStateAction<BusinessEditPhotoProps[]>
  >;
  fileStatuses: { [key: number]: "uploading" | "success" | "failed" };
  setFileStatuses: React.Dispatch<
    React.SetStateAction<{ [key: number]: "uploading" | "success" | "failed" }>
  >;
  isDragOver: boolean;
  setIsDragOver: React.Dispatch<React.SetStateAction<boolean>>;
  handleFileSelect: (files: FileList | null) => void;
  handleDragOver: (e: React.DragEvent) => void;
  handleDragLeave: (e: React.DragEvent) => void;
  handleDrop: (e: React.DragEvent) => void;
  handleFileInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  removeFile: (index: number) => void;
  retryUpload: (index: number) => void;
  previewFile: (file: File | BusinessEditPhotoProps) => void;
}

export interface IProgressIndicatorProps {
  currentStep: number;
  totalSteps: number;
}

export interface INavigationButtonsProps {
  currentStep: number;
  totalSteps: number;
  onNext: () => void;
  onPrevious: () => void;
  onSkip: () => void;
  isSubmitting?: boolean;
  isNextDisabled?: boolean;
}
